var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 6.25H1.875M10 1.25V3.75M5 1.25V3.75M6.5625 8.75L7.5 8.125V11.25M6.71875 11.25H8.28125M4.875 13.75H10.125C11.1751 13.75 11.7001 13.75 12.1012 13.5456C12.454 13.3659 12.7409 13.079 12.9206 12.7262C13.125 12.3251 13.125 11.8001 13.125 10.75V5.5C13.125 4.4499 13.125 3.92485 12.9206 3.52377C12.7409 3.17096 12.454 2.88413 12.1012 2.70436C11.7001 2.5 11.1751 2.5 10.125 2.5H4.875C3.8249 2.5 3.29985 2.5 2.89877 2.70436C2.54596 2.88413 2.25913 3.17096 2.07936 3.52377C1.875 3.92485 1.875 4.4499 1.875 5.5V10.75C1.875 11.8001 1.875 12.3251 2.07936 12.7262C2.25913 13.079 2.54596 13.3659 2.89877 13.5456C3.29985 13.75 3.8249 13.75 4.875 13.75Z",
    stroke: "#898F9D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDate);
export default __webpack_public_path__ + "static/media/calendar-date.528d4ab618e09bcd252f98f9d6b78f04.svg";
export { ForwardRef as ReactComponent };